import $ from 'jquery';
import barba from '@barba/core';
import { gsap } from 'gsap';

import { elementPosition, enableBodyScroll, replaceBodyClasses, scrollPosition, wait } from '../global/helpers';
import { $Elements, Events, Classes, Elements, Durations, BarbaLinks, Breakpoints } from '../global/constants';

// ---------- Barba Initialisation ----------

barba.init({
	debug: false,
	timeout: 10000,
	preventRunning: true,
	prevent: ({ el }) => !$(el).is(BarbaLinks),
	transitions: [{
		sync: true,
		once: async() => $Elements.window.on('load', pageLoaded),
		enter: async() => $Elements.document.one(Events.page.transition, pageLoaded),
		leave: async(data) => {

			Elements.LoadingBar.classList.add(Classes.loading);

			if(isMenuImageLink(data)) {
				await menuImageTransition(data);
			}
			else if(isWinesImageLink(data)) {
				await winesImageTransition(data);
			}
			else {
				await defaultTransition(data);
			}

			return true;
		},
		after: async(data) => {

			window.scrollTo(0, 0);

			replaceBodyClasses(data.next);

			$('.' + Classes.transitionClone).remove();

			$Elements.document.trigger(Events.page.transition);

			return true;
		}
	}]
});

// ---------- Transitions ----------

function prepareForTransition(data) {

	const scroll = scrollPosition();
	data.next.container.style.top = scroll.scrollTop + 'px';

	data.current.container.classList.add(Classes.leaving);
	document.body.classList.add(Classes.leaving);

	if(document.body.classList.contains(Classes.searchOpen)) {
		document.body.classList.remove(Classes.searchOpen);
		enableBodyScroll();
	}

	if(document.body.classList.contains(Classes.menuWineRangeOpen)) {
		document.body.classList.remove(Classes.menuWineRangeOpen);
		enableBodyScroll();
	}
}

async function pageLoaded() {

	$Elements.document.trigger(Events.page.enter);
	Elements.MainWrapper.classList.remove(Classes.loading, Classes.initialLoad);
	Elements.LoadingBar.classList.remove(Classes.loading);

	return true;
}

// ---------- Default Transition ----------

async function defaultTransition(data) {

	prepareForTransition(data);

	if(document.body.classList.contains(Classes.menuOpen)) {
		document.body.classList.remove(Classes.menuOpen);
		enableBodyScroll();
	}

	document.body.classList.remove(Classes.menuLight);

	await gsap.to(data.current.container, { opacity: 0, duration: Durations.page.s });

	await wait(100);

	window.scrollTo(0, 0);
	data.next.container.style.top = 0;

	return true;
}

// ---------- Menu Transition ----------

function isMenuImageLink(data) {
	return (typeof data.trigger !== 'string' && data.trigger.classList.contains('barba-menu-link'));
}

async function menuImageTransition(data) {

	prepareForTransition(data);

	$(data.next.container).find('.menu-wrapper, .header-wrapper').addClass(Classes.hidden);

	const image = document.querySelector('.menu-image[data-menu="' + data.trigger.dataset.image + '"]');

	if(window.innerWidth >= Breakpoints.mobile) {

		if(image) {

			await gsap.to(image, {
				width: '100%',
				autoRound: false,
				duration: Durations.page.s
			});
		}

		await wait(100);
	}

	await gsap.to(data.current.container, { opacity: 0, duration: Durations.page.s });

	document.body.classList.remove(Classes.menuLight);

	if(document.body.classList.contains(Classes.menuOpen)) {
		document.body.classList.remove(Classes.menuOpen);
		enableBodyScroll(Elements.MenuWrapper);
	}

	await wait(100);

	window.scrollTo(0, 0);
	data.next.container.style.top = 0;
	$(data.next.container).find('.menu-wrapper, .header-wrapper').removeClass(Classes.hidden);

	return true;
}

// ---------- Wines Transition ----------

function isWinesImageLink(data) {
	return (typeof data.trigger !== 'string' && data.trigger.getAttribute('target') === 'wine-range');
}

async function winesImageTransition(data) {

	$(data.next.container).find('.menu-wine-range-wrapper, .header-wrapper').addClass(Classes.hidden);
	data.current.container.classList.add(Classes.leaving);

	const link = data.trigger.parentNode;
	const windowWidth = window.innerWidth;
	const windowHeight = window.innerHeight;

	const position = elementPosition(link);
	const scroll = scrollPosition();
	const clone = link.cloneNode(true);
	const image = clone.querySelector('.column-image');

	clone.classList.add(Classes.transitionClone);
	clone.classList.remove(Classes.active);

	gsap.set(clone, { ...position });

	link.classList.add(Classes.leaving);

	await wait(Durations.page.ms);

	document.body.appendChild(clone);

	if(image) {

		$(image).find('img').each(function() {
			$(this).attr('sizes', window.innerWidth + 'px');
		});

		gsap.to(image, {
			x: 0,
			y: 0,
			autoRound: false,
			duration: Durations.page.s
		});
	}

	await gsap.to(clone, {
		x: -position.left,
		y: scroll.scrollTop - position.top,
		width: window.innerWidth,
		maxWidth: window.innerWidth,
		height: '100vh',
		autoRound: false,
		duration: Durations.page.s
	});

	prepareForTransition(data);

	await wait(Durations.page.ms);

	window.scrollTo(0, 0);
	data.next.container.style.top = 0;
	$(data.next.container).find('.menu-wine-range-wrapper, .header-wrapper').removeClass(Classes.hidden);

	return true;
}
